import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer3ZakladanieOgrodu() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/zakladanie-ogrodow-Large.jpeg"
          alt="Zakładanie ogrodu - kompleksowe usługi ogrodnicze - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Kompleksowe zakładanie ogrodów pod klucz Gdańsk, Gdynia, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Tworzymy piękne przestrzenie zielone wokół domów na Pomorzu
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Specjalizujemy się w kompleksowym zakładaniu ogrodów od A do Z wokół nowych inwestycji na terenie Gdańska, Gdyni, Wejherowa, Kartuz i całych Kaszub. Wykonujemy nasadzenia roślin, skarpy, nasypy, <a href="/zakladanie-ogrodu/trawa-z-rolki" className="underline hover:opacity-80">trawniki z rolki</a> i siewu oraz montujemy <a href="/zakladanie-ogrodu/nawadnianie" className="underline hover:opacity-80">systemy nawadniania</a>. Przemienimy Twoją działkę po budowie w zieloną oazę spokoju.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zakładanie Ogrodu – Projekty ogrodów
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zakładanie ogrodu z profesjonalnym wsparciem
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co zyskujesz dzięki naszemu wsparciu?
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usługi ogrodnicze
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Projekt ogrodu i jego realizacja
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zakładanie ogrodów – Trójmiasto i całe Pomorze
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Funkcjonalny i piękny zarazem – razem stwórzmy idealną przestrzeń
              ogrodu
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dla kogo kierujemy swoją ofertę?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Zakładanie Ogrodu – Projekty ogrodów</h2>
          <p>
            Przygotowanie terenu, założenie trawników, projekt nasadzeń,
            instalacji nawadniających czy elementów architektury ogrodowej to
            nie lada wyzwanie, które wymaga wiedzy, doświadczenia oraz
            niezbędnego sprzętu. Często realizacja wymarzonej przestrzeni
            ogrodowej okazuje się o wiele trudniejsza niż początkowo nam się
            wydaje, dlatego doskonałym sposobem na stworzenie ogrodu idealnego
            jest zatrudnienie specjalistycznej firmy oferującej usługi
            ogrodnicze.
          </p>
          <p>
            Zakładanie ogrodu to kompleksowa usługa, którą jako eksperci pełni
            pasji i zamiłowania do kreowania zielonych przestrzeni oferujemy na
            Pomorzu, szczególnie w rejonie Trójmiasta.
          </p>

          <h2 id="2">Zakładanie ogrodu z profesjonalnym wsparciem</h2>
          <p>
            Zakładanie ogrodu z profesjonalnym wsparciem to kompleksowe wsparcie
            oraz gwarancja udanej realizacji. Zawodowi ogrodnicy dysponują nie
            tylko wiedzą, ale i odpowiednimi maszynami i urządzeniami, a przy
            tym oferują dostawę roślin, materiałów czy elementów ogrodowych od
            najlepszych producentów. Jeżeli pragniesz stworzyć wymarzoną
            przestrzeń od początku do końca, zaoszczędzić sporo pieniędzy na
            próbach i błędach, a przy tym zyskać piękny ogród stworzony z pomocą
            fachowców – jesteśmy do dyspozycji.
          </p>

          <h2 id="3">Co zyskujesz dzięki naszemu wsparciu?</h2>
          <p>
            Po pierwsze – nasz zespół zadba o przygotowanie doskonałego projektu
            ogrodu, który w pełni odpowie na Twoje oczekiwania, potrzeby, a przy
            tym pomoże stworzyć przestrzeń pełną urzekających zakątków.
            Przygotowanie planu zagospodarowania ogrodu możemy wykonywać na
            podstawie Twoich własnych pomysłów i sugestii, ale i zrealizować
            autorskie kreacje ogrodowe dopasowane do ogólnych wytycznych.
          </p>
          <p>
            Naszym celem jest tworzenie bajkowych ogrodów, które staną się
            piękną ozdobą Gdańska, Gdyni, Sopotu, ale i innych zakątków Pomorza,
            a nawet całej Polski!
          </p>

          <h2 id="4">Usługi ogrodnicze</h2>
          <p>
            W ramach naszej działalności oferujemy kompleksowe usługi
            ogrodnicze, które obejmują:
          </p>
          <ul>
            <li>Oczyszczenie i przygotowanie terenu</li>
            <li>Niwelacja terenu i utwardzanie powierzchni</li>
            <li>
              Zakładanie trawników i nasadzenia zgodnie z projektem ogrodu
            </li>
            <li>Budowa i montaż automatycznych systemów nawadniających</li>
            <li>Tworzenie oczek wodnych, kaskad i strumyków</li>
            <li>Wykorzystanie geokraty do wzmocnienia nawierzchni gruntu</li>
            <li>
              Wykonywanie utwardzonych traktów komunikacyjnych (chodników,
              alejek, schodków)
            </li>
            <li>
              Tworzenie dekoracyjnych aranżacji z małej architektury ogrodowej
            </li>
            <li>Kreowanie skalniaków i kompozycji roślinnych</li>
            <li>Sadzenie bylin, krzewów, drzew i kwiatów</li>
            <li>Montaż oświetlenia ogrodowego</li>
          </ul>

          <h2 id="5">Projekt ogrodu i jego realizacja</h2>
          <p>
            Metamorfoza ogrodu z naszą pomocą to niezwykła przygoda i
            niesamowity proces, który możesz obserwować na każdym jego etapie.
            Po wstępnym stworzeniu planu zagospodarowania oraz projektu ogrodu
            realizujemy:
          </p>
          <ol>
            <li>
              Prace ziemne – oczyszczanie i przygotowanie terenu pod nasadzenia,
              zbiorniki wodne itp.
            </li>
            <li>
              Instalacje elektryczne i nawadniające, aby wzbogacić ogród o
              oświetlenie i kompozycje wodne
            </li>
            <li>
              Wykonywanie odpowiedniej nawierzchni, aby rośliny i kompozycje
              prezentowały się wyjątkowo
            </li>
            <li>
              Realizacja elementów architektury ogrodowej, oczek wodnych itp.
            </li>
            <li>
              Nasadzenie roślin, dostosowane do ich wymagań w zakresie
              oświetlenia i nawodnienia
            </li>
            <li>Zakładanie trawników zarówno z siewu, jak i z rolki</li>
          </ol>

          <h2 id="6">Zakładanie ogrodów – Trójmiasto i całe Pomorze</h2>
          <p>
            Każdy projekt ogrodu wymaga dbałości o najdrobniejsze szczegóły,
            gdzie niezwykle ważną rolę odgrywa budżet, jaki pragniesz
            przeznaczyć na stworzenie ogrodu marzeń. Zakładanie ogrodu już na
            etapie projektowania wymaga kalkulacji, uwzględniającej rośliny,
            przestrzeń trawnika, lokalizację rabatek kwiatowych oraz elementy
            dekoracyjne.
          </p>

          <h2 id="7">
            Funkcjonalny i piękny zarazem – razem stwórzmy idealną przestrzeń
            ogrodu
          </h2>
          <p>
            Tworzenie ogrodu wymaga dbałości o najdrobniejsze detale. Jego
            kompozycja powinna być funkcjonalna i zaplanowana tak, aby
            korzystanie z jego uroków było przyjemnością, a pielęgnacja mało
            kłopotliwa. Ogród to nie tylko miejsce do podziwiania piękna
            kompozycji roślinnych, ale także przestrzeń do relaksu, zabaw z
            dziećmi i spotkań z przyjaciółmi.
          </p>
          <p>
            Planowanie ogrodu powinno być spójne ze stylistyką domu. Idealnie
            jest, gdy współpracują architekt budowlany i krajobrazu. Jeśli
            jednak planujesz przestrzeń samodzielnie, weź kartkę, ołówek i puść
            wodze wyobraźni. Połączenie Twoich pomysłów z wiedzą i
            doświadczeniem profesjonalistów pozwoli uzyskać spektakularny efekt!
          </p>

          <h2 id="8">Dla kogo kierujemy swoją ofertę?</h2>
          <p>
            Nasze wsparcie i kompleksową ofertę zakładania ogrodów kierujemy
            zarówno do osób prywatnych, jak i deweloperów, instytucji, firm,
            placówek oświatowych, osiedli oraz wspólnot mieszkaniowych. Z naszą
            pomocą możliwe jest stworzenie niezwykłych parków, skwerów,
            zieleńców, klombów i innych przestrzeni zielonych.
          </p>
          <p>
            Zapraszamy do wspólnego kreowania i zagospodarowania Twojego ogrodu
            marzeń.
          </p>

          <h2 id="8">Nasadzenia</h2>
          <p>
            Nasadzenia w ogrodzie to kluczowy element, który nadaje przestrzeni
            wyjątkowego charakteru. Oferujemy kompleksowe usługi nasadzeń na
            skarpach i schodach, tworząc piękne i funkcjonalne kompozycje
            roślinne, które doskonale wkomponują się w każdy ogród.
          </p>
          <img
            className="rounded-xl"
            src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/zakladanie-ogrodow-1.jpeg"
            alt="Nasadzenia w ogrodzie - skarpy i schody - realizacja Drzewus"
          />
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Zobacz, jak krok po kroku tworzymy i urządzamy ogrody marzeń od podstaw. Nasze realizacje obejmują zarówno małe przydomowe ogródki, jak i duże tereny rekreacyjne.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-1.jpg"
              alt="Realizacja ogrodu Drzewus - założony ogród nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Realizacja ogrodu Drzewus - założony ogród nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Realizacja ogrodu Drzewus - założony ogród nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-4.jpg"
              alt="Realizacja ogrodu Drzewus - założony ogród nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-1.jpg"
              alt="Realizacja ogrodu Drzewus - założony ogród nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio ogrodu Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio ogrodu Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio ogrodu Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio ogrodu Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio ogrodu Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio ogrodu Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer3ZakladanieOgrodu;
